/** `rihanna@school.org` → `r***@school.org`: enough to tell accounts apart in support, not enough to identify the person. */
export const maskEmailForLog = (email: string | null | undefined) => {
  if (!email) {
    return email;
  }
  const at = email.lastIndexOf("@");
  if (at <= 0) {
    return "***";
  }
  return `${email.charAt(0)}***${email.slice(at)}`;
};

/** `+19735551234` → `***1234` */
export const maskPhoneNumberForLog = (
  phoneNumber: string | null | undefined,
) => {
  if (!phoneNumber) {
    return phoneNumber;
  }
  const digits = phoneNumber.replace(/\D/g, "");
  return `***${digits.slice(-4)}`;
};
